export const siteStats = [
  { value: "3200+", label: "已收录事件" },
  { value: "48.6万", label: "话题关注人数" },
  { value: "每日", label: "更新频率" },
  { value: "12个", label: "内容板块" },
];

export const categories = [
  { name: "综艺", icon: "ri-live-line", desc: "选秀、综艺与幕后动态", count: 68 },
  { name: "直播", icon: "ri-live-line", desc: "带货、主播与平台规则", count: 54 },
  { name: "影视", icon: "ri-movie-2-line", desc: "剧集、短剧与片场话题", count: 73 },
  { name: "演出", icon: "ri-music-2-line", desc: "音乐节、巡演与票务", count: 41 },
  { name: "消费", icon: "ri-store-2-line", desc: "餐饮、商品与体验争议", count: 62 },
  { name: "电竞", icon: "ri-gamepad-line", desc: "赛事、转会与俱乐部", count: 39 },
  { name: "文娱", icon: "ri-book-2-line", desc: "创作、版权与内容行业", count: 47 },
  { name: "自媒体", icon: "ri-smartphone-line", desc: "博主、内容真实与平台", count: 58 },
];

export const hotList = [
  { rank: 1, title: "选秀选手合约条款讨论升温", category: "综艺", topicId: "xuanxiu-contract", heat: "986万", tag: "更新" },
  { rank: 2, title: "直播专场退货率引发费用争议", category: "直播", topicId: "livestream-return", heat: "874万", tag: "热" },
  { rank: 3, title: "短剧剧组结算问题集中出现", category: "影视", topicId: "shorts-wage", heat: "762万", tag: "更新" },
  { rank: 4, title: "电竞转会窗口合同分歧", category: "电竞", topicId: "dj-club-transfer", heat: "612万", tag: "热" },
  { rank: 5, title: "音乐节票务退改规则讨论", category: "演出", topicId: "festival-ticket", heat: "521万", tag: "平" },
  { rank: 6, title: "网红餐厅后厨整改进行中", category: "消费", topicId: "restaurant-safety", heat: "468万", tag: "更新" },
  { rank: 7, title: "旅行博主素材来源受质疑", category: "自媒体", topicId: "travel-blogger", heat: "448万", tag: "热" },
];

export const bigEvents = [
  { date: "09-10", month: "9月10日", title: "选秀合约讨论延伸至行业惯例", category: "综艺" },
  { date: "09-09", month: "9月9日", title: "平台就直播价格争议启动核查", category: "直播" },
  { date: "09-08", month: "9月8日", title: "经纪公司发布合规声明", category: "综艺" },
  { date: "09-06", month: "9月6日", title: "短剧协会提出结算规范设想", category: "影视" },
  { date: "09-04", month: "9月4日", title: "网红餐厅宣布暂停营业整改", category: "消费" },
  { date: "09-02", month: "9月2日", title: "电竞联盟回应转会窗口流程", category: "电竞" },
];

export const featuredArticles = [
  {
    id: "feat-1",
    title: "为什么热门事件总在三天后迎来第二波讨论",
    excerpt: "一条消息从出现到被反复讨论，中间往往经历几个固定阶段。理解这个节奏，追热点就不会手忙脚乱。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20paper%20texture%20with%20crimson%20ink%20swirls%2C%20minimal%20editorial%20still%20life%2C%20soft%20natural%20light%2C%20no%20text&width=900&height=700&seq=feat-article-01&orientation=landscape",
    category: "观察",
    readTime: "6分钟",
    author: "编辑部",
    date: "09-09",
  },
  {
    id: "feat-2",
    title: "合约、分成与解约：新人签约前该看懂的三件事",
    excerpt: "把一份经纪合同拆开看，真正影响长期收入与自由度的，往往不是签约金，而是几条容易被忽略的细则。",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20contract%20document%20and%20fountain%20pen%20on%20warm%20wooden%20desk%2C%20editorial%20product%20photography%2C%20amber%20tones&width=900&height=700&seq=feat-article-02&orientation=landscape",
    category: "解读",
    readTime: "8分钟",
    author: "内容组",
    date: "09-08",
  },
  {
    id: "feat-3",
    title: "直播低价背后的价格链条是怎么算出来的",
    excerpt: "从品牌、渠道到主播团队，一件商品的价格由多方共同决定。看懂分工，就能理解为什么同一件东西会出现多个价。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20paper%20layers%20with%20soft%20shadows%2C%20minimal%20editorial%20still%20life%2C%20no%20text%2C%20no%20people&width=900&height=700&seq=feat-article-03&orientation=landscape",
    category: "解读",
    readTime: "7分钟",
    author: "内容组",
    date: "09-06",
  },
  {
    id: "feat-4",
    title: "追一个事件时，怎样快速分辨信息的新旧",
    excerpt: "同一个话题里常常混着几天前的截图。三个小方法，帮你判断一条消息是不是已经过期。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20warm%20toned%20clock%20and%20papers%20on%20beige%20background%2C%20editorial%20still%20life%2C%20soft%20light%2C%20no%20text&width=900&height=700&seq=feat-article-04&orientation=landscape",
    category: "方法",
    readTime: "5分钟",
    author: "编辑部",
    date: "09-04",
  },
];

export const faqList = [
  {
    question: "蝌蚪黑料主要整理哪些内容？",
    answer:
      "我们把全网正在被讨论的热门事件按话题整理成合集，包括事件起因、关键进展和后续更新。内容聚焦可公开查证的公开信息，帮助你在一个页面里看完整条脉络。",
  },
  {
    question: "事件合集和普通新闻列表有什么不同？",
    answer:
      "普通列表按时间堆放单条消息，合集则围绕一个话题把分散的信息串起来。每个合集都带有时间线，你可以按日期依次了解事情是怎么发展的。",
  },
  {
    question: "合集里的内容会持续更新吗？",
    answer:
      "会。带「持续更新中」标记的合集，会在有新的公开进展时补充到时间线里，并在合集顶部显示最近更新时间，方便你只关注新变化。",
  },
  {
    question: "如何快速找到我关心的话题？",
    answer:
      "可以在顶部搜索框输入关键词，也可以进入「事件合集」页按综艺、直播、影视、演出等板块筛选。首页的今日热榜则汇总了当下讨论量最高的几个话题。",
  },
  {
    question: "网站上的信息可以直接作为结论使用吗？",
    answer:
      "我们做的是信息梳理，不做判断和定性。涉及具体争议时，请以当事人、平台或官方渠道的正式说明为准。合集页也会标注信息来源方向，方便你自行核对。",
  },
  {
    question: "发现内容有误，怎么反馈？",
    answer:
      "可以在「关于我们」页通过联系表单发送反馈，注明具体合集名称和你认为需要修正的地方，我们会尽快核对并更新。",
  },
];